import { render, staticRenderFns } from "./comboList.vue?vue&type=template&id=5d0d6a44"
import script from "./comboList.vue?vue&type=script&lang=js"
export * from "./comboList.vue?vue&type=script&lang=js"
import style0 from "./comboList.vue?vue&type=style&index=0&id=5d0d6a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports